// extracted by mini-css-extract-plugin
export var animateCircle = "chip-module--animate-circle--OP1II";
export var bounce = "chip-module--bounce--xQVXL";
export var chip = "chip-module--chip--Ojr+H";
export var ldsRing = "chip-module--lds-ring--v7pbU";